import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1254;
const HERO_IMG_HEIGHT = 1254;
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-98" data-mp="1297ahz3tqr77">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[32rem] -translate-x-1/2 rounded-full bg-sand blur-3xl" aria-hidden data-id="element-99" data-mp="128pgza8jqr2z" />

      <div className="relative mx-auto max-w-xl px-5 pb-6 pt-3.5 text-center sm:max-w-3xl sm:pb-10 sm:pt-8" data-id="element-100" data-mp="sa9szg4tfxxp">
        <div className="animate-hero-copy" data-id="element-101" data-mp="nbey3ftkqix8">
          <p className="font-display text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.7rem]" data-id="element-102" data-mp="3d1ik78o21amw">
            Sistema práctico para emprender desde tu cocina
          </p>
          <h1 className="mt-2 font-display text-[1.55rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[2.4rem]" data-id="element-103" data-mp="3j8ixl0k6uiv8">
            Postres que Venden<span className="align-super text-[0.5em]" data-id="element-104" data-mp="3o73pmcpadw8l">™</span>
          </h1>
          <p className="mx-auto mt-2 max-w-[28ch] font-display text-[1.02rem] font-bold leading-[1.25] tracking-tight text-charcoal sm:max-w-[38ch] sm:text-[1.45rem]" data-id="element-105" data-mp="399bavmrkdbvg">
            De guardar recetas a tener{' '}
            <span className="text-gold" data-id="element-106" data-mp="30h9eq0oj2hqz">tu propuesta de postres lista para ofrecer</span>
          </p>
        </div>

        <div className="relative mx-auto mt-2.5 w-[64%] max-w-[230px] sm:mt-5 sm:w-[66%] sm:max-w-[370px]" data-id="element-107" data-mp="35a2ial89fk1h">
          <span className="absolute inset-x-4 bottom-5 top-6 -z-0 rounded-[3rem] bg-coral-soft blur-2xl" aria-hidden data-id="element-108" data-mp="2qhqvjmgfyzzz" />
          <img src={HERO_IMG} alt="Mockup oficial del libro Postres que Venden™" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 64vw, 370px" style={{
          aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
        }} className="animate-hero-media relative block h-auto w-full object-contain drop-shadow-[0_22px_30px_rgba(56,37,34,0.22)]" data-id="element-109" data-mp="2hix40ahywzta" />
        </div>

        <p className="mx-auto mt-2.5 max-w-[36ch] font-sans text-[0.83rem] font-medium leading-snug text-taupe sm:max-w-[50ch] sm:text-[0.95rem]" data-id="element-110" data-mp="deq8aed7t21z">
          El ebook digital que te ayuda a{' '}
          <strong className="font-bold text-charcoal" data-id="element-111" data-mp="162capjapi0n9">elegir qué preparar</strong>, organizar tu
          producción, calcular tus costos y empezar a ofrecer tus postres desde casa.
        </p>

        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-112" data-mp="x0cugt7in0ld">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-113" data-mp="3lqm4435bldx1" data-mpi={i}>
              {i > 0 && <span className="h-1 w-1 rounded-full bg-gold" aria-hidden data-id="element-114" data-mp="3hqam6y4cdrp9" />}
              <li className="font-display text-[0.66rem] font-bold uppercase tracking-[0.06em] text-charcoal sm:text-[0.76rem]" data-id="element-115" data-mp="1x9ukg9uwtbmw">
                {fact}
              </li>
            </React.Fragment>)}
        </ul>

        <PriceBlock className="mt-3" layout="inline" size="sm" data-id="element-116" data-mp="2697lce4ywrw0" />

        <div className="mt-3 flex justify-center" data-id="element-117" data-mp="2b0fynl9f4xeg">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-118" data-mp="2b20qv489g495" />
        </div>

        <p className="mt-2 font-sans text-[0.72rem] font-medium text-taupe" data-id="element-119" data-mp="2fyr83uvsx5w5">
          Producto digital · Pago único · Acceso inmediato
        </p>
      </div>
    </section>;
}